module.exports = __webpack_public_path__ + "img/Team Work.118027e0.svg";